<template>
  <div>
    <nav id="nav" class="navbar navbar-expand-xl">
      <button id="navToggler" class="navbar-toggler bg-dark navbar-dark" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse center" id="collapsibleNavbar">
        <ul class="navbar-nav left-align col-sm">
          <li id="topNavMargin" class="nav-item home">
            <router-link class="nav-link" to="/">
              <i class="fa fa-home"></i> Home
            </router-link>
          </li>
          <li class="nav-item mechanics">
            <router-link class="nav-link" to="/Mechanics">
              <i class="fa-solid fa-gears"></i> Mechanics
            </router-link>
          </li>
          <li class="nav-item classes">
            <router-link class="nav-link" to="/Classes">
              <i class="fa-solid fa-hand-fist"></i> Classes
            </router-link>
          </li>
          <li class="nav-item races">
            <router-link class="nav-link" to="/Races">
              <i class="fa-solid fa-person"></i> Races
            </router-link>
          </li>
          <li class="nav-item weapons">
            <router-link class="nav-link" to="/Weapons">
              <i class="fa-solid fa-shield"></i> Weapons
            </router-link>
          </li>
          <li class="nav-item dice">
            <router-link class="nav-link" to="/Dice">
              <i class="fa-solid fa-dice"></i> Dice
            </router-link>
          </li>
          <li class="nav-item analysis">
            <router-link class="nav-link" to="/Analysis">
              <i class="fa-solid fa-flask-vial"></i> Analysis
            </router-link>
          </li>
          <li class="nav-item setting">
            <router-link class="nav-link" to="/Setting">
              <i class="fa-solid fa-dungeon"></i> Setting
            </router-link>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>
<script>
export default {
  Navbar: 'Navbar'
}
</script>
<style lang="scss">
.home .router-link-exact-active {
  background-color: #c42f24;
}
.mechanics .router-link-exact-active {
  background-color: #c7ae20;
}
.classes .router-link-exact-active {
  background-color: #71ad40;
}
.races .router-link-exact-active {
  background-color: #5ab188;
}
.weapons .router-link-exact-active {
  background-color: #4484b8;
}
.dice .router-link-exact-active {
  background-color: #365ba1;
}
.analysis .router-link-exact-active {
  background-color: #9046ad;
}
.setting .router-link-exact-active {
  background-color: #640e86;
}
.btn-check:focus+.btn, .btn:focus {
  outline: none !important; 
  box-shadow: none !important;
}
.navbar-toggler:focus {
  outline: none !important; 
  box-shadow: none !important;
}
.nav-item {
  padding: none;
	display: inline-block;
	text-decoration: none; 
	transition: all 0.25s;
	background-size: 100% 200%;
	// &.home {
  //   background-image: linear-gradient(to top, #c01f13 50%, transparent 50%);
  //   min-width: 90px;
  // }
  &.home {
    background-image: linear-gradient(to top, #e42604 50%, transparent 50%);
    min-width: 150px;
  }
  &.mechanics {
    background-image: linear-gradient(to top, #c9ad0d 50%, transparent 50%);
    min-width: 150px;
  }
  &.classes {
    background-image: linear-gradient(to top, #6ab82a 50%, transparent 50%);
    min-width: 150px;
  }
  &.races {
    background-image: linear-gradient(to top, #02bb64 50%, transparent 50%);
    min-width: 150px;
  }
  &.weapons {
    background-image: linear-gradient(to top, #4484b8 50%, transparent 50%);
    min-width: 150px;
  }
  &.dice {
    background-image: linear-gradient(to top, #365ba1 50%, transparent 50%);
    min-width: 150px;
  }
  &.analysis {
    background-image: linear-gradient(to top, #9b58b6 50%, transparent 50%);
    min-width: 150px;
  }
  &.setting {
    background-image: linear-gradient(to top, #7f0fac 50%, transparent 50%);
    min-width: 150px;
  }
  
  // &.spellcasting {
  //   background-image: linear-gradient(to top, #00379c 50%, transparent 50%);
  //   min-width: 140px;
  // }
  // &.weapons {
  //   background-image: linear-gradient(to top, #7c00ad 50%, transparent 50%);
  //   min-width: 190px;
  // }
  // &.login {
  //   background-image: linear-gradient(to top, #38001f 50%, transparent 50%);
  // }
  // &.pc {
  //   background-image: linear-gradient(to top, #140d36 50%, transparent 50%);
  //   min-width: 80px;
  // }
  &:hover {
    background-position: 0 100%; 
	  color: #fff;
  }
}
.nav-link {
  color: white;
    &:hover, &:focus { 
      color: white;
    cursor: pointer;
  }
}
#login {
  text-align: left;
}
#nav {
  background-color: #0e0c0c;
  border-bottom: 2px solid #2b2b2b;
  a {
    color: white;
    &.router-link-exact-active {
      font-weight: bold;
      color: black;
    }
  }
}
#navToggler {
  padding: 10px 10px 10px 10px;
  margin-top: 5px;
  margin-right: 5px;
  margin-bottom: 15px;
  margin-left: 15px;
}

@media only screen and (max-width: 768px) {
  .navbar {
    padding-top: 15px;
  }
}
@media only screen and (max-width: 1199px) {
  // #login {
  //   margin-bottom: -10px;
  // }
  #topNavMargin {
    margin-top: 10px;
  }
  div {
    ul {
      li { 
        i:first-child {
          padding-left: 40%;
        }
      }
    }
    #collapsibleNavbar2 {
      a {
        padding-left:40%;
      }
      width: 100%;
    }
  }
}
@media only screen and (min-width: 1199px) {
  #nav {
    height: 41px;
  }
  .nav-item {
    min-width: 125px;
  }
  div {
    ul {
      li { 
        margin: -10px 0px -10px 0px;
      }
    }
  }
}
</style>
